var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('shared-pricing',{staticClass:"pt-travel-cost-applied"},[_c('travel-info',{staticClass:"pt-travel-cost-applied__travel-info"}),_vm._v(" "),_c('applied-actions')],1)}
var staticRenderFns = []

export { render, staticRenderFns }